import React from 'react';
import { ShareButtons } from './ShareButtons';

interface RotatingCalloutProps {
  title: string;
  url: string;
}

export const RotatingCallout: React.FC<RotatingCalloutProps> = ({ title, url }) => {
  const shareMessages = [
    "Found this helpful? Share it with your trading community 👇",
    "Think this was valuable? Spread the knowledge 🧠",
    "Help your fellow traders — share this post 🔁",
    "Like what you read? Share it forward 🔥",
    "Let others benefit too — hit share below 💬"
  ];

  const randomMessage = shareMessages[Math.floor(Math.random() * shareMessages.length)];

  return (
    <>
      <p className="text-yellow-300 text-sm sm:text-base italic mb-2 transition-transform duration-300 hover:scale-105">
        {randomMessage}
      </p>
      <ShareButtons title={title} url={url} />
    </>
  );
};
